import { Component, Input } from '@angular/core';
import { User } from '../../models/user';

@Component({
  selector: 'app-print-receipt',
  templateUrl: './print-receipt.component.html',
  styleUrls: ['./print-receipt.component.scss']
})
export class PrintReceiptComponent {
  @Input() public receiptDetails: any;
  @Input() public companyLogo: string;
  @Input() public shipmentType: string;
  @Input() public user: User;
  @Input() public selectedCustomer: any;
  @Input() public hideStatusCodes: boolean;
  @Input() public hideParcelInfo: boolean;
  @Input() public hideRating: boolean;
  @Input() public hideSignature: boolean;
  @Input() public hideDestinationAddress: boolean;
  @Input() public hideOriginAddress: boolean;
  @Input() public hideLogo: boolean; // FR-004, FR-005: Control logo visibility
  @Input() public hideRequiredDriverInputs: boolean; // XD-54630
  @Input() public dateTimeFormat: any;
}
